import validate from "/opt/atlassian/pipelines/agent/build/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45guard_45global from "/opt/atlassian/pipelines/agent/build/apps/frontends/middleware/authGuard.global.ts";
import locales from "/opt/atlassian/pipelines/agent/build/packages/upa-i18n/dist/runtime/middleware/pathLocalization.mjs";
export const globalMiddleware = [
  validate,
  auth_45guard_45global,
  locales
]
export const namedMiddleware = {}